import React from "react";
import classes from "./ProjectsContainer.module.css";

const ProjectsContainer = (props) => {
  return <div className={classes.container}>{props.children}</div>;
};

export default ProjectsContainer;
